import Component from '@glimmer/component';
import type { HeadlessFormComponentSignature } from 'ember-headless-form/components/headless-form';
import { type UserData } from '../../../../-private/types.ts';
import type { FormData, FormKey, ValidationError } from 'ember-headless-form';
import TextareaControl, {
  type TextareaControlSignature
} from '../../../../components/form/controls/textarea.gts';
import Confirmation from '../confirmation.gts';
import Errors from '../errors.gts';

export interface WrFormInputRowSignature<
  DATA extends UserData,
  KEY extends FormKey<FormData<DATA>> = FormKey<FormData<DATA>>
> {
  Element: TextareaControlSignature['Element'];
  Args: {
    label?: string;
    confirmation?: string;
    form: HeadlessFormComponentSignature<DATA, unknown>['Blocks']['default'][0];
    name: KEY;
  };
  Blocks: {
    default?: [];
  };
}

export default class WrFormFieldsRowsTextareaComponent<
  DATA extends UserData
> extends Component<WrFormInputRowSignature<DATA>> {
  get isConfirmed() {
    return Boolean(this.args?.confirmation);
  }

  hasError(rawErrors?: ValidationError<DATA[FormKey<FormData<DATA>>]>[]) {
    if (!rawErrors) return false;
    return rawErrors.length > 0;
  }

  <template>
    <@form.Field @name={{@name}} as |field|>
      <div class='flex flex-col'>
        {{#if @label}}
          <field.Label for={{field.id}}>{{@label}}</field.Label>
        {{/if}}

        <TextareaControl
          id={{field.id}}
          aria-invalid={{field.isInvalid}}
          aria-describedby={{field.errorId}}
          name={{@name}}
          {{! @glint-expect-error introduced in https://github.com/Semeia-io/Platform/pull/6437. Will be fixed in an upcoming PR}}
          @value={{field.value}}
          {{! @glint-expect-error introduced in https://github.com/Semeia-io/Platform/pull/6437. Will be fixed in an upcoming PR}}
          @onChange={{field.setValue}}
          @isConfirmed={{this.isConfirmed}}
          @hasError={{field.isInvalid}}
          ...attributes
        />

        {{#if @confirmation}}
          <Confirmation @confirmation={{@confirmation}} />
        {{/if}}

        {{#if field.isInvalid}}
          <Errors @field={{field}} />
        {{/if}}
      </div>
    </@form.Field>
  </template>
}
